import { z } from 'zod';

/**
 * Dutch postal code pattern: 4 digits (first cannot be 0) followed by 2 letters.
 * Spaces are stripped before validation.
 */
const DUTCH_POSTAL_CODE = /^[1-9]\d{3}[A-Za-z]{2}$/;

export const addressFormSchema = z.object({
  postalCode: z
    .string()
    .min(1, 'Voer een postcode in')
    .transform((val) => val.replace(/\s/g, '').trim().toUpperCase())
    .refine((val) => DUTCH_POSTAL_CODE.test(val), {
      message: 'Voer een geldige postcode in (bijv. 1234AB)',
    }),
  houseNumber: z
    .string()
    .min(1, 'Voer een huisnummer in')
    .refine((val) => /^\d+$/.test(val.trim()), {
      message: 'Voer een geldig huisnummer in',
    })
    .transform((val) => val.trim()),
  houseNumberAddition: z
    .string()
    .transform((val) => val.trim())
    .default(''),
});
